import Vue from 'vue';
import axios from 'axios';
import App from './App';
import router from './router';
import store from './store/state';

const timings = new Map();
function logModuleUsage(moduleName) {
  const startTime = timings.get(moduleName);
  const now = new Date();
  const usageTime = (now - startTime) / 1000;
  if (usageTime > 5) {
    axios.post('/aims/api/logModuleUsage', {
      module: moduleName,
      timeSpent: (now - startTime) / 1000,
    });
  }
}
router.beforeEach((to, from, next) => {
  const now = new Date();
  timings.set(to.name, now);
  next();
});
router.afterEach((to, from) => {
  if (timings.has(from.name)) {
    logModuleUsage(from.name);
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  store,
  mounted() {
    window.onbeforeunload = () => {
      if (timings.has(this.$router.currentRoute.name)) {
        logModuleUsage(this.$router.currentRoute.name);
      }
    };
  },
});



// WEBPACK FOOTER //
// ./src/main.js